import React, { useEffect, useState } from "react";

import "./goondemand.css";


import AllImg from "./images/all.png";
import CommunityImg from "./images/community.png";
import GroupImg from "./images/group.png";
import onDemandImg from "./images/on-demand.png";
import PracticeImg from "./images/practice.png";
import Speaker from "./images/speaker.png";
import { getOndemandCategories } from "../../../services/admin";
import GoOnDemandPractice1 from "./goOnDemandPractice1";
import { useSearchParams } from "react-router-dom";

export default function GoOnDemandPractice() {
  const [searchParams] = useSearchParams();
  const comingFrom = searchParams.get("to");
  const [sessions, setSessions] = useState([]);
  const [showTabs, setShowTabs] = useState(true);
  const [session_id, setsession_id] = useState('');


  useEffect(() => {
    if (comingFrom == "ondemand" || comingFrom == "groupcoaching" || comingFrom == "practicecircles" || comingFrom == "speakerEvents" || comingFrom == "coachedgroupcoaching" || comingFrom == "communitysupportgroups" || comingFrom =="allpracticecircles") {
      setShowTabs(false);

    }
    getOndemandCategories().then((data) => {
      // if (data.data.status) {
      console.log(data.data.data);
      let array = data.data.data
      const newObject = { id: 0, sub_session_name: 'All Practice Circles' }
      array.splice(1, 0, newObject);
      setSessions(array)
      console.log(array, "array");
      // }
    })

  }, [])

  const setNewSessionId = (id) => {
    setsession_id(id);
    setShowTabs(false);
  }


  return (
    <>
      {showTabs ?

        <div className="container-fluid ">
          <div className="container-fluid ">
            <div className="dashboard ">
              <div className="row">
                <div className="col-md-12">
                  <div className="quck-box">
                    <h2>Select Session Type</h2>
                    <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                      {sessions.slice(0, 3).map((item) => <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={item.id == 91 ? onDemandImg : item.id == 0 ? PracticeImg : GroupImg} alt="count" />
                          </div>
                          <span>
                            {item.sub_session_name}

                          </span>
                        </div>
                      </div>)}
                    </div>
                    <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                      {sessions.slice(3, 8).map((item) => <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={item.id == 96 ? CommunityImg : item.id == 95 ? Speaker : AllImg} alt="count" />
                          </div>
                          <span>

                            {item.sub_session_name}
                          </span>
                        </div>
                      </div>)}
                      {sessions.length > 0 && <div
                        onClick={() => setNewSessionId('all')}
                        className="upcoming-comlilated pointer"
                      >
                        <div className="content-left">
                          <div className="icon-left">
                            <img src={AllImg} alt="count" />
                          </div>
                          <span>

                            {'All of the above'}
                          </span>
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        :
        <GoOnDemandPractice1 setSessions={setSessions} sessions={sessions} session_id={session_id} setsession_id={setsession_id} />
      }
    </>
  );
}
